import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  Grid,
  Header,
  Label,
  Table,
  Icon,
  Popup,
  Image,
} from 'semantic-ui-react';
import BankIcon from './BankIcon';
import icPreferredGreen from '../assets/icons/ic_preferred_green.svg';
import HLBRewardsTag from '../components/HLBCampaign/HLBRewardsTag';

const SummaryTable = ({ custom, summary }) => {
  const { t } = useTranslation();
  return (
  <small>
    <Table className={custom ? 'custom' : null} unstackable fixed basic="very" columns={5} textAlign="center" size="small" compact>
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell>{t('Total', { ns: 'constants' })}</Table.HeaderCell>
          <Table.HeaderCell>{t('Pending', { ns: 'constants' })}</Table.HeaderCell>
          <Table.HeaderCell>{t('Approved', { ns: 'constants' })}</Table.HeaderCell>
          <Table.HeaderCell>{t('Success', { ns: 'constants' })}</Table.HeaderCell>
          <Table.HeaderCell>{t('Rejected', { ns: 'constants' })}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          summary && summary.length > 0 ? (
            <Table.Row>
              <Table.Cell>{summary[0].count}</Table.Cell>
              <Table.Cell>{summary[0].pendingCount}</Table.Cell>
              <Table.Cell>{summary[0].approvedCount}</Table.Cell>
              <Table.Cell>{summary[0].successCount}</Table.Cell>
              <Table.Cell>{summary[0].rejectCount}</Table.Cell>
            </Table.Row>
          ) : (
            <Table.Row>
              <Table.Cell>0</Table.Cell>
              <Table.Cell>0</Table.Cell>
              <Table.Cell>0</Table.Cell>
              <Table.Cell>0</Table.Cell>
              <Table.Cell>0</Table.Cell>
            </Table.Row>
          )
        }
      </Table.Body>
    </Table>
  </small>
  );
};

SummaryTable.propTypes = {
  custom: PropTypes.bool,
  summary: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
  })),
};

const checkBankerUserIsOnboarding = banker => banker.user && banker.user.statusID === '200';

const BankerItem = ({
  custom,
  className,
  onClick,
  onPoint,
  banker,
  selected,
  disabled,
  checkable,
  leftComponent,
  rightComponent,
  showSummary,
  isHLBCampaign, // to determine whether need to use updated UI or not
  isHLBCampaignBank, // to determine whether banker is participating in HLB campaign
}) => {
  const { t } = useTranslation();
  let mobile = 15;
  if (!checkable && rightComponent) {
    mobile = 9;
    if (banker.directToBank && banker.bank.logoSrc) {
      mobile = 12;
    }
  }
  return (
    <Grid
      columns="equal"
      verticalAlign="middle"
      className={`banker-item ${className || ''} ${(!isHLBCampaign && checkBankerUserIsOnboarding(banker)) && 'inactive-case dark'}`}
      onClick={(event) => {
        if (!disabled && onClick) {
          onClick(event, banker);
        }
      }}
    >
      {
        leftComponent || checkable ?
          <Grid.Column textAlign="center" mobile={2} tablet={2} computer={1}>
            {
              checkable ?
                <Checkbox
                  checked={selected}
                  disabled={disabled}
                  readOnly
                /> :
                leftComponent
            }
          </Grid.Column> :
          null
      }
      {
        isHLBCampaign && (
          <Grid.Column textAlign="center" mobile={3} tablet={2} computer={2}>
            <BankIcon bankID={banker.bankID} type="round" />
          </Grid.Column>
        )
      }
      {
        isHLBCampaign || checkable || rightComponent ? null :
        <Grid.Column textAlign="center" mobile={3} tablet={2} computer={leftComponent ? 1 : 2}>
          <BankIcon bankID={banker.bankID} type="round" />
        </Grid.Column>
      }
      <Grid.Column>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column>
              <Grid columns="equal">
                {
                  (checkable && !rightComponent) || (banker.directToBank && banker.bank.logoSrc) ?
                  null : (
                    <Grid.Column mobile={3} tablet={4} computer={3}>
                      <BankIcon bankID={banker.bankID} type="round" />
                    </Grid.Column>
                  )
                }
                <Grid.Column
                  mobile={mobile}
                  tablet={12}
                  computer={11}
                >
                  <Header
                    as="h4"
                    className="clickable"
                    onClick={onPoint}
                  >
                    {
                      banker.directToBank && banker.bank.logoSrc ? (
                        <Header.Content style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <Image src={banker.bank.logoSrc} style={{ maxHeight: '35px' }} />
                          {
                            banker.bank.isExclusive ? (
                              <Header.Subheader style={{ display: 'flex', color: '#21BA45', alignItems: 'center', fontWeight: '100', marginLeft: '0.5em' }}>
                                <Image src={icPreferredGreen} height="15" style={{ marginRight: '0.25em' }} />
                                {showSummary ? '' : 'Preferred'}
                              </Header.Subheader>
                            ) : null
                          }
                        </Header.Content>
                      ) : (
                        <Header.Content>
                          <span style={{ marginRight: '.3em' }}>{banker.name}</span>
                          {banker.isFeatured && <span style={{ color: 'orange', marginLeft: '0.25em' }}>&#9733;</span>}
                          {
                            banker.bankTeamBanker && banker.bankTeamBanker.isTeamLeader &&
                            <Popup
                              trigger={
                                <Icon.Group className="team-leader" size="small">
                                  <Icon size="big" color="blue" name="certificate" />
                                  <Icon size="small" name="user" inverted />
                                </Icon.Group>
                              }
                              content={t('Team Leader', { ns: 'translation' })}
                              inverted
                              position="top center"
                            />
                          }
                          {
                            (checkBankerUserIsOnboarding(banker) || banker.pendingOnboarding) &&
                              <Label style={{ marginLeft: 0 }} size="tiny" color="orange" content={t('Pending Registration', { ns: 'translation' })} />
                          }
                          <Header.Subheader>
                            <p>{banker.mobilePrefix}{banker.mobile}</p>
                            {banker.bank ? banker.bank.name : null} {banker.bankBranch ?
                                banker.bankBranch.name : null}
                          </Header.Subheader>
                        </Header.Content>
                      )
                    }
                  </Header>
                </Grid.Column>
                {
                  custom && rightComponent ?
                    <Grid.Column className={custom ? 'computer-hide' : null} textAlign="right" mobile={4} tablet={2} computer={rightComponent ? 2 : 1}>
                      {rightComponent}
                    </Grid.Column> : null
                }
              </Grid>
            </Grid.Column>
            {
              showSummary ?
                <Grid.Column only={checkable ? null : 'mobile'}>
                  <SummaryTable custom={custom} summary={banker.summary} />
                </Grid.Column> : null
            }
          </Grid.Row>
        </Grid>
      </Grid.Column>
      {
        !checkable && showSummary ?
          <Grid.Column textAlign="right" tablet={7} computer={6} className="mobile-hide">
            <SummaryTable custom={custom} summary={banker.summary} />
          </Grid.Column> : null
      }
      {
        isHLBCampaignBank && (
          <Grid.Column textAlign="center" mobile={3} tablet={2} computer={5} style={{ display: 'flex', alignItems: 'end' }}>
            <HLBRewardsTag />
          </Grid.Column>
        )
      }
      {
        !isHLBCampaign && (checkable || rightComponent) ?
          <Grid.Column className={custom ? 'mobile-hide' : null} textAlign="center" mobile={4} tablet={2} computer={rightComponent ? 3 : 2}>
            {rightComponent || (banker.directToBank && banker.bank.logoSrc ? null : <BankIcon bankID={banker.bankID} type="round" />)}
          </Grid.Column> : null
      }
    </Grid>
  );
};

BankerItem.propTypes = {
  custom: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onPoint: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  checkable: PropTypes.bool,
  banker: PropTypes.shape({
    preferredName: PropTypes.string,
  }),
  leftComponent: PropTypes.node,
  rightComponent: PropTypes.node,
  showSummary: PropTypes.bool,
  isHLBCampaign: PropTypes.bool,
  isHLBCampaignBank: PropTypes.bool,
};

export default BankerItem;



// WEBPACK FOOTER //
// ./src/components/BankerItem.jsx